/* eslint-disable */
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, FindDefaultBillTo } from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SetInitialValues";
import { getBillTos } from "@insite/client-framework/Services/CustomersService";

replaceInChain(chain, FindDefaultBillTo, async function (props) {
    // b2bes override in base to prevent loading all billtos for the current user 
    // this prevents scenario for 'canviewallcustomers' users who will try to load all customers in one api call
    const billToCollection = await getBillTos({ pageSize: 50 });
    const billTos = billToCollection.billTos!;

    if (billTos.length === 1) {
        props.defaultBillTo = billTos[0];
    } else {
        const defaultBillTos = billTos.filter(o => o.isDefault);

        if (defaultBillTos.length === 1) {
            props.defaultBillTo = defaultBillTos[0];
        }
    }
});
